// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".triangle-orange{\r\n    color: orange;\r\n}", "",{"version":3,"sources":["webpack://./src/app/hr/employee-details/employee-details.component.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB","sourcesContent":[".triangle-orange{\r\n    color: orange;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
